/*eslint no-case-declarations: "off"*/

import { LinkingMessageData, nativeLinking, nativeOpenBrowser, nativePrint, WebBrowserResultType } from './bridge/NativeApi';
import { platform } from './Common';

export * from './Common';

export { UserInstance, getUser } from './User';

export async function openLinkInBrowser(url: string, navigate?: boolean) {
  switch (platform()) {
    case 'ios':
    case 'android':
      const response = await nativeOpenBrowser(url);
      if (typeof response == 'object' && 'result' in response) {
        if (response.result == WebBrowserResultType.OPENED) {
          return true;
        }
      }
      break;

    default:
      if (navigate || undefined === navigate) {
        window.open(url, '_blank');
      }
      break;
  }
  return false;
}

export async function linking(message: LinkingMessageData) {
  switch (platform()) {
    case 'ios':
    case 'android':
      const response = await nativeLinking(message);
      return true;
      break;

    default:
      if (message.operation == 'openURL' && message.openURL) {
        window.open(message.openURL, '__blank');
      }
      break;
  }
  return false;
}

export async function print(options?: {
  filterHTML?: (html: string) => string;
}) {
  switch (platform()) {
    case 'ios':
    case 'android': {
      if (document.body.parentElement) {
        document.body.className += ' native-printing';
        let html = document.body.parentElement.innerHTML;
        document.body.className = document.body.className.replace(' native-printing', '');

        if (options?.filterHTML) {
          html = options.filterHTML(html);
        }

        await nativePrint(html);
        return true;
      } else {
        return false;
      }
    }

    default: {
      setTimeout(() => {
        try {
          // Workaround for Safari browser
          const resp = document.execCommand('print', false, '');
          if (!resp) {
            window.print();
          }
        } catch (e) {
          // All other browsers
          window.print();
        }
      }, 500);
      return true;
    }
  }
}
